import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _allowOneTimePurchasesRequest = {};
var _allowOneTimePurchasesResponse = {};
var _assignSubscriptionOptionsToProductRequest = {
    assignedSubscriptionOptions: '_subscriptionOptionInProduct',
};
var _assignSubscriptionOptionsToProductResponse = {};
var _bulkCalculatePricesRequest = {};
var _bulkCalculatePricesRequestV2 = {};
var _bulkCalculatePricesResponse = {
    calculatedPrices: 'Map#_calculatePricesResponse',
};
var _bulkCalculatePricesResponseItem = {
    calculatedPrices: 'Map#_calculatePricesResponse',
};
var _bulkCalculatePricesResponseV2 = {
    calculatedPricesPerProduct: '_bulkCalculatePricesResponseItem',
};
var _bulkCreateSubscriptionOptionsRequest = {
    subscriptionOptions: '_subscriptionOption',
};
var _bulkCreateSubscriptionOptionsResponse = {
    subscriptionOptions: '_subscriptionOption',
};
var _bulkDeleteSubscriptionOptionsRequest = {};
var _bulkDeleteSubscriptionOptionsResponse = {};
var _bulkUpdateSubscriptionOptionsRequest = {
    subscriptionOptions: '_subscriptionOption',
};
var _bulkUpdateSubscriptionOptionsResponse = {
    subscriptionOptions: '_subscriptionOption',
};
var _calculatePricesRequest = { price: 'DOUBLE' };
var _calculatePricesResponse = {
    originalPrice: 'DOUBLE',
    prices: '_subscriptionOptionPrices',
};
var _createSubscriptionOptionRequest = {
    subscriptionOption: '_subscriptionOption',
};
var _createSubscriptionOptionResponse = {
    subscriptionOption: '_subscriptionOption',
};
var _deleteSubscriptionOptionRequest = {};
var _deleteSubscriptionOptionResponse = {};
var _discount = { value: 'DOUBLE' };
var _getOneTimePurchasesStatusRequest = {};
var _getOneTimePurchasesStatusResponse = {};
var _getProductIdsForSubscriptionOptionRequest = {};
var _getProductIdsForSubscriptionOptionResponse = {};
var _getSubscriptionOptionRequest = {};
var _getSubscriptionOptionResponse = {
    subscriptionOption: '_subscriptionOption',
};
var _getSubscriptionOptionsForProductRequest = {};
var _getSubscriptionOptionsForProductResponse = {
    subscriptionOptions: '_subscriptionOptionInProduct',
};
var _listSubscriptionOptionsRequest = {};
var _listSubscriptionOptionsResponse = {
    subscriptionOptions: '_subscriptionOption',
};
var _subscriptionOption = { discount: '_discount' };
var _subscriptionOptionInProduct = { discount: '_discount' };
var _subscriptionOptionPriceData = { discountedPrice: 'DOUBLE' };
var _subscriptionOptionPrices = {
    priceData: '_subscriptionOptionPriceData',
    convertedPriceData: '_subscriptionOptionPriceData',
};
var _updateSubscriptionOptionRequest = {
    subscriptionOption: '_subscriptionOption',
};
var _updateSubscriptionOptionResponse = {
    subscriptionOption: '_subscriptionOption',
};
function resolveWixEcommerceSubscriptionOptionApiV1SubscriptionOptionsReadApiUrl(opts) {
    var domainToMappings = {
        'api._api_base_domain_': [
            {
                srcPath: '/wix-ecommerce-plans-reader',
                destPath: '',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/wix-ecommerce-plans-reader',
                destPath: '',
            },
        ],
        _: [
            {
                srcPath: '/_api/subscription-options-reader-server',
                destPath: '',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/subscription-options-reader-server',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
function resolveWixEcommerceSubscriptionOptionApiV1SubscriptionOptionsWriteApiUrl(opts) {
    var domainToMappings = {
        'api._api_base_domain_': [
            {
                srcPath: '/wix-ecommerce-plans',
                destPath: '',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/stores/v1/subscription-options',
                destPath: '/v1/subscription-options',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/subscription-options-server',
                destPath: '',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/subscription-options-server',
                destPath: '',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/subscription-options-server',
                destPath: '',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/subscription-options-server',
                destPath: '',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/subscription-options-server',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/**
 * Creates a subscription option.
 * To assign to a product, call [Assign Subscription Options to Product](https://dev.wix.com/api/rest/wix-stores/subscription-options/assign-subscription-options-to-product).
 * Subscription options that are not assigned to a product will not be visible in the Wix business manager.
 */
export function createSubscriptionOption(payload) {
    var _a = serializer(_createSubscriptionOptionRequest, { _discount: _discount, _subscriptionOption: _subscriptionOption }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createSubscriptionOptionResponse, {
        _discount: _discount,
        _subscriptionOption: _subscriptionOption,
    }).fromJSON;
    function __createSubscriptionOption(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.stores.v1.subscription_option',
            method: 'POST',
            methodFqn: 'wix.ecommerce.subscription.option.api.v1.SubscriptionOptionsWriteApi.CreateSubscriptionOption',
            url: resolveWixEcommerceSubscriptionOptionApiV1SubscriptionOptionsWriteApiUrl({ protoPath: '/v1/subscription-options', data: serializedData, host: host }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createSubscriptionOption.fromReq = fromReq;
    return __createSubscriptionOption;
}
/**
 * Updates a subscription option.
 * Only parameters passed will be updated.
 */
export function updateSubscriptionOption(payload) {
    var _a = serializer(_updateSubscriptionOptionRequest, { _discount: _discount, _subscriptionOption: _subscriptionOption }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateSubscriptionOptionResponse, {
        _discount: _discount,
        _subscriptionOption: _subscriptionOption,
    }).fromJSON;
    function __updateSubscriptionOption(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.stores.v1.subscription_option',
            method: 'PATCH',
            methodFqn: 'wix.ecommerce.subscription.option.api.v1.SubscriptionOptionsWriteApi.UpdateSubscriptionOption',
            url: resolveWixEcommerceSubscriptionOptionApiV1SubscriptionOptionsWriteApiUrl({
                protoPath: '/v1/subscription-options/{subscriptionOption.id}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateSubscriptionOption.fromReq = fromReq;
    return __updateSubscriptionOption;
}
/** Deletes a subscription option. */
export function deleteSubscriptionOption(payload) {
    var _a = serializer(_deleteSubscriptionOptionRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_deleteSubscriptionOptionResponse, {}).fromJSON;
    function __deleteSubscriptionOption(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.stores.v1.subscription_option',
            method: 'DELETE',
            methodFqn: 'wix.ecommerce.subscription.option.api.v1.SubscriptionOptionsWriteApi.DeleteSubscriptionOption',
            url: resolveWixEcommerceSubscriptionOptionApiV1SubscriptionOptionsWriteApiUrl({
                protoPath: '/v1/subscription-options/{id}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __deleteSubscriptionOption.fromReq = fromReq;
    return __deleteSubscriptionOption;
}
/**
 * Creates multiple subscription options (up to 100).
 * To assign to a product, call [Assign Subscription Options to Product](https://dev.wix.com/api/rest/wix-stores/subscription-options/assign-subscription-options-to-product).
 * Subscription options that are not assigned to a product will not be visible in the Wix business manager.
 */
export function bulkCreateSubscriptionOptions(payload) {
    var _a = serializer(_bulkCreateSubscriptionOptionsRequest, { _discount: _discount, _subscriptionOption: _subscriptionOption }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkCreateSubscriptionOptionsResponse, { _discount: _discount, _subscriptionOption: _subscriptionOption }).fromJSON;
    function __bulkCreateSubscriptionOptions(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.stores.v1.subscription_option',
            method: 'POST',
            methodFqn: 'wix.ecommerce.subscription.option.api.v1.SubscriptionOptionsWriteApi.BulkCreateSubscriptionOptions',
            url: resolveWixEcommerceSubscriptionOptionApiV1SubscriptionOptionsWriteApiUrl({
                protoPath: '/v1/subscription-options/createBulk',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkCreateSubscriptionOptions.fromReq = fromReq;
    return __bulkCreateSubscriptionOptions;
}
/**
 * Updates multiple subscription options.
 * Only parameters passed will be updated.
 */
export function bulkUpdateSubscriptionOptions(payload) {
    var _a = serializer(_bulkUpdateSubscriptionOptionsRequest, { _discount: _discount, _subscriptionOption: _subscriptionOption }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkUpdateSubscriptionOptionsResponse, { _discount: _discount, _subscriptionOption: _subscriptionOption }).fromJSON;
    function __bulkUpdateSubscriptionOptions(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.stores.v1.subscription_option',
            method: 'PATCH',
            methodFqn: 'wix.ecommerce.subscription.option.api.v1.SubscriptionOptionsWriteApi.BulkUpdateSubscriptionOptions',
            url: resolveWixEcommerceSubscriptionOptionApiV1SubscriptionOptionsWriteApiUrl({ protoPath: '/v1/subscription-options', data: serializedData, host: host }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkUpdateSubscriptionOptions.fromReq = fromReq;
    return __bulkUpdateSubscriptionOptions;
}
/** Deletes multiple subscription options. */
export function bulkDeleteSubscriptionOptions(payload) {
    var _a = serializer(_bulkDeleteSubscriptionOptionsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkDeleteSubscriptionOptionsResponse, {}).fromJSON;
    function __bulkDeleteSubscriptionOptions(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.stores.v1.subscription_option',
            method: 'POST',
            methodFqn: 'wix.ecommerce.subscription.option.api.v1.SubscriptionOptionsWriteApi.BulkDeleteSubscriptionOptions',
            url: resolveWixEcommerceSubscriptionOptionApiV1SubscriptionOptionsWriteApiUrl({
                protoPath: '/v1/subscription-options/deleteBulk',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkDeleteSubscriptionOptions.fromReq = fromReq;
    return __bulkDeleteSubscriptionOptions;
}
/**
 * Assign up to 6 subscription options to a specified product.
 * Pass an empty array to remove all subscription options assigned to a product.
 */
export function assignSubscriptionOptionsToProduct(payload) {
    var _a = serializer(_assignSubscriptionOptionsToProductRequest, { _discount: _discount, _subscriptionOptionInProduct: _subscriptionOptionInProduct }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_assignSubscriptionOptionsToProductResponse, {}).fromJSON;
    function __assignSubscriptionOptionsToProduct(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.stores.v1.subscription_option',
            method: 'POST',
            methodFqn: 'wix.ecommerce.subscription.option.api.v1.SubscriptionOptionsWriteApi.AssignSubscriptionOptionsToProduct',
            url: resolveWixEcommerceSubscriptionOptionApiV1SubscriptionOptionsWriteApiUrl({
                protoPath: '/v1/subscription-options/product/{productId}/assign',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __assignSubscriptionOptionsToProduct.fromReq = fromReq;
    return __assignSubscriptionOptionsToProduct;
}
/**
 * Allow for one-time purchase of a product.
 * By default, product can be sold only as part of a subscription, not as a one-time purchase.
 */
export function allowOneTimePurchases(payload) {
    var _a = serializer(_allowOneTimePurchasesRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_allowOneTimePurchasesResponse, {}).fromJSON;
    function __allowOneTimePurchases(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.stores.v1.subscription_option',
            method: 'PATCH',
            methodFqn: 'wix.ecommerce.subscription.option.api.v1.SubscriptionOptionsWriteApi.AllowOneTimePurchases',
            url: resolveWixEcommerceSubscriptionOptionApiV1SubscriptionOptionsWriteApiUrl({
                protoPath: '/v1/subscription-options/product/{productId}/allowOneTimePurchase',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __allowOneTimePurchases.fromReq = fromReq;
    return __allowOneTimePurchases;
}
/** Retrieves a subscription option by ID. */
export function getSubscriptionOption(payload) {
    var _a = serializer(_getSubscriptionOptionRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getSubscriptionOptionResponse, {
        _discount: _discount,
        _subscriptionOption: _subscriptionOption,
    }).fromJSON;
    function __getSubscriptionOption(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.stores.v1.subscription_option',
            method: 'GET',
            methodFqn: 'wix.ecommerce.subscription.option.api.v1.SubscriptionOptionsReadApi.GetSubscriptionOption',
            url: resolveWixEcommerceSubscriptionOptionApiV1SubscriptionOptionsReadApiUrl({
                protoPath: '/v1/subscription-options/{id}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getSubscriptionOption.fromReq = fromReq;
    return __getSubscriptionOption;
}
/**
 * Retrieves all subscription options assigned to a specified product.
 * By default, hidden subscription options are not returned. To retrieve all subscription options you must pass `includeHiddenSubscriptionOptions = true`.
 */
export function getSubscriptionOptionsForProduct(payload) {
    var _a = serializer(_getSubscriptionOptionsForProductRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getSubscriptionOptionsForProductResponse, { _discount: _discount, _subscriptionOptionInProduct: _subscriptionOptionInProduct }).fromJSON;
    function __getSubscriptionOptionsForProduct(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.stores.v1.subscription_option',
            method: 'GET',
            methodFqn: 'wix.ecommerce.subscription.option.api.v1.SubscriptionOptionsReadApi.GetSubscriptionOptionsForProduct',
            url: resolveWixEcommerceSubscriptionOptionApiV1SubscriptionOptionsReadApiUrl({
                protoPath: '/v1/subscription-options/byProduct/{productId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getSubscriptionOptionsForProduct.fromReq = fromReq;
    return __getSubscriptionOptionsForProduct;
}
/**
 * Returns the specified subscription options.
 * If the specified subscription option doesn't exist, the request will be successful but the response will be empty.
 */
export function listSubscriptionOptions(payload) {
    var _a = serializer(_listSubscriptionOptionsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listSubscriptionOptionsResponse, {
        _discount: _discount,
        _subscriptionOption: _subscriptionOption,
    }).fromJSON;
    function __listSubscriptionOptions(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.stores.v1.subscription_option',
            method: 'POST',
            methodFqn: 'wix.ecommerce.subscription.option.api.v1.SubscriptionOptionsReadApi.ListSubscriptionOptions',
            url: resolveWixEcommerceSubscriptionOptionApiV1SubscriptionOptionsReadApiUrl({
                protoPath: '/v1/subscription-options/list',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __listSubscriptionOptions.fromReq = fromReq;
    return __listSubscriptionOptions;
}
/**
 * calculates discounted price when specified subscription option applied to given price
 * before open to users it should support price calculations by productId/variantId in addition to price
 */
export function calculatePrices(payload) {
    var _a = serializer(_calculatePricesRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_calculatePricesResponse, {
        _subscriptionOptionPriceData: _subscriptionOptionPriceData,
        _subscriptionOptionPrices: _subscriptionOptionPrices,
    }).fromJSON;
    function __calculatePrices(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.stores.v1.subscription_option',
            method: 'POST',
            methodFqn: 'wix.ecommerce.subscription.option.api.v1.SubscriptionOptionsReadApi.CalculatePrices',
            url: resolveWixEcommerceSubscriptionOptionApiV1SubscriptionOptionsReadApiUrl({
                protoPath: '/v1/subscription-options/calculate',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __calculatePrices.fromReq = fromReq;
    return __calculatePrices;
}
/**
 * calculates discounted price when specified subscription option applied for each of prices provided
 * before open to users it should support price calculations by productId/variantId in addition to price
 */
export function bulkCalculatePrices(payload) {
    var _a = serializer(_bulkCalculatePricesRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkCalculatePricesResponse, {
        _calculatePricesResponse: _calculatePricesResponse,
        _subscriptionOptionPriceData: _subscriptionOptionPriceData,
        _subscriptionOptionPrices: _subscriptionOptionPrices,
    }).fromJSON;
    function __bulkCalculatePrices(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.stores.v1.subscription_option',
            method: 'POST',
            methodFqn: 'wix.ecommerce.subscription.option.api.v1.SubscriptionOptionsReadApi.BulkCalculatePrices',
            url: resolveWixEcommerceSubscriptionOptionApiV1SubscriptionOptionsReadApiUrl({
                protoPath: '/v1/subscription-options/calculateBulk',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkCalculatePrices.fromReq = fromReq;
    return __bulkCalculatePrices;
}
/** calculates discounted price when specified subscription option applied for each of prices provided for each product */
export function bulkCalculatePricesForProducts(payload) {
    var _a = serializer(_bulkCalculatePricesRequestV2, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkCalculatePricesResponseV2, {
        _bulkCalculatePricesResponseItem: _bulkCalculatePricesResponseItem,
        _calculatePricesResponse: _calculatePricesResponse,
        _subscriptionOptionPriceData: _subscriptionOptionPriceData,
        _subscriptionOptionPrices: _subscriptionOptionPrices,
    }).fromJSON;
    function __bulkCalculatePricesForProducts(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.stores.v1.subscription_option',
            method: 'POST',
            methodFqn: 'wix.ecommerce.subscription.option.api.v1.SubscriptionOptionsReadApi.BulkCalculatePricesForProducts',
            url: resolveWixEcommerceSubscriptionOptionApiV1SubscriptionOptionsReadApiUrl({
                protoPath: '/v1/subscription-options/calculateBulkForProducts',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkCalculatePricesForProducts.fromReq = fromReq;
    return __bulkCalculatePricesForProducts;
}
/** Retrieves the IDs of products associated with a specified subscription option. */
export function getProductIdsForSubscriptionOption(payload) {
    var _a = serializer(_getProductIdsForSubscriptionOptionRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getProductIdsForSubscriptionOptionResponse, {}).fromJSON;
    function __getProductIdsForSubscriptionOption(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.stores.v1.subscription_option',
            method: 'GET',
            methodFqn: 'wix.ecommerce.subscription.option.api.v1.SubscriptionOptionsReadApi.GetProductIdsForSubscriptionOption',
            url: resolveWixEcommerceSubscriptionOptionApiV1SubscriptionOptionsReadApiUrl({
                protoPath: '/v1/subscription-options/{id}/productIds',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getProductIdsForSubscriptionOption.fromReq = fromReq;
    return __getProductIdsForSubscriptionOption;
}
/** Checks whether a specified product (associated with subscription options) is available for one-time purchase. */
export function getOneTimePurchasesStatus(payload) {
    var _a = serializer(_getOneTimePurchasesStatusRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getOneTimePurchasesStatusResponse, {}).fromJSON;
    function __getOneTimePurchasesStatus(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.stores.v1.subscription_option',
            method: 'GET',
            methodFqn: 'wix.ecommerce.subscription.option.api.v1.SubscriptionOptionsReadApi.GetOneTimePurchasesStatus',
            url: resolveWixEcommerceSubscriptionOptionApiV1SubscriptionOptionsReadApiUrl({
                protoPath: '/v1/subscription-options/product/{productId}/oneTimePurchasesStatus',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getOneTimePurchasesStatus.fromReq = fromReq;
    return __getOneTimePurchasesStatus;
}
//# sourceMappingURL=http.impl.js.map